<template>
  <pt-third-vendor-form class="pt-third-vendor-form__page"></pt-third-vendor-form>
</template>

<script>
import PtThirdVendorForm from 'cps/mall-manage/pt-third-vendors/pt-third-vendor-form'
export default {
  name: 'pt-third-vendor-form__view',
  components: {
    'pt-third-vendor-form': PtThirdVendorForm
  }
}
</script>
